var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      staticClass: "station-edit-dialog",
      attrs: {
        "append-to-body": "",
        visible: _vm.innerVisible,
        title: _vm.title,
        width: "400px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _vm.innerVisible
        ? _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "110px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "baseInfo.overseaWarehouse.warehouseCode"
                        ),
                        required: ""
                      }
                    },
                    [
                      _c("el-input", {
                        directives: [
                          { name: "uppercase", rawName: "v-uppercase" }
                        ],
                        staticStyle: { width: "200px" },
                        attrs: {
                          disabled: !_vm.isAdmin && _vm.form.ifFba,
                          no: "warehouseCode"
                        },
                        model: {
                          value: _vm.form.warehouseCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "warehouseCode", $$v)
                          },
                          expression: "form.warehouseCode"
                        }
                      })
                    ],
                    1
                  ),
                  !_vm.isAdmin && !_vm.form.ifFba
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "baseInfo.overseaWarehouse.countryChineseName"
                            ),
                            required: ""
                          }
                        },
                        [
                          _c("el-input", {
                            directives: [
                              { name: "uppercase", rawName: "v-uppercase" }
                            ],
                            staticStyle: { width: "200px" },
                            attrs: { no: "countryChineseName" },
                            model: {
                              value: _vm.form.countryChineseName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "countryChineseName", $$v)
                              },
                              expression: "form.countryChineseName"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  !_vm.isAdmin && !_vm.form.ifFba
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "baseInfo.overseaWarehouse.countryEnglishName"
                            ),
                            required: ""
                          }
                        },
                        [
                          _c("el-input", {
                            directives: [
                              { name: "uppercase", rawName: "v-uppercase" }
                            ],
                            staticStyle: { width: "200px" },
                            attrs: { no: "countryEnglishName" },
                            model: {
                              value: _vm.form.countryEnglishName,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "countryEnglishName", $$v)
                              },
                              expression: "form.countryEnglishName"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("baseInfo.overseaWarehouse.country"),
                        required: ""
                      }
                    },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          "select-type": _vm.selectTypeNames.basic_data_Country,
                          cache: false,
                          no: "country",
                          filterable: "",
                          "callback-params": { key: "countryCode" },
                          "callback-method-type": "value",
                          "default-value": _vm.form.countryCode,
                          "static-options": _vm.countryList,
                          disabled: !_vm.isAdmin && _vm.form.ifFba
                        },
                        on: { parentCallBack: _vm.selectCargoItem }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("baseInfo.overseaWarehouse.province")
                      }
                    },
                    [
                      _c("el-input", {
                        directives: [
                          { name: "uppercase", rawName: "v-uppercase" }
                        ],
                        staticStyle: { width: "200px" },
                        attrs: {
                          disabled: !_vm.isAdmin && _vm.form.ifFba,
                          no: "province"
                        },
                        model: {
                          value: _vm.form.province,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "province", $$v)
                          },
                          expression: "form.province"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("baseInfo.overseaWarehouse.city"),
                        required: ""
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px", "margin-right": "5px" },
                        attrs: { disabled: "", no: "city" },
                        model: {
                          value: _vm.form.cityName,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "cityName", $$v)
                          },
                          expression: "form.cityName"
                        }
                      }),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            type: "primary",
                            no: "cityBtn",
                            disabled: !_vm.isAdmin && _vm.form.ifFba
                          },
                          on: { click: _vm.cityClickHandler }
                        },
                        [_vm._v("...")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("baseInfo.overseaWarehouse.zipCode"),
                        required: ""
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          no: "zipCode",
                          disabled: !_vm.isAdmin && _vm.form.ifFba
                        },
                        model: {
                          value: _vm.form.zipCode,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "zipCode", $$v)
                          },
                          expression: "form.zipCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("baseInfo.overseaWarehouse.ifFba")
                      }
                    },
                    [
                      _c("el-checkbox", {
                        attrs: { no: "ifFba", disabled: "" },
                        model: {
                          value: _vm.form.ifFba,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "ifFba", $$v)
                          },
                          expression: "form.ifFba"
                        }
                      })
                    ],
                    1
                  ),
                  !_vm.isAdmin && !_vm.form.ifFba
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "baseInfo.overseaWarehouse.warehouseAgeCalculationRulesEdit"
                            )
                          }
                        },
                        [
                          _c("cargo-advance-select", {
                            staticStyle: { width: "200px" },
                            attrs: {
                              no: "warehouseAgeCalculationRules",
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames
                                  .local_cache_FbaJobConstants$WAREHOUSE_AGE_CALCULATION_RULES,
                              "callback-method-type": "value",
                              "default-value":
                                _vm.form.warehouseAgeCalculationRules,
                              "callback-params": {
                                key: "warehouseAgeCalculationRules"
                              },
                              clearable: false
                            },
                            on: { parentCallBack: _vm.selectCargoItem }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("baseInfo.overseaWarehouse.address"),
                        required: ""
                      }
                    },
                    [
                      _c("el-input", {
                        directives: [
                          { name: "uppercase", rawName: "v-uppercase" }
                        ],
                        staticStyle: { width: "200px" },
                        attrs: {
                          no: "address",
                          disabled: !_vm.isAdmin && _vm.form.ifFba
                        },
                        model: {
                          value: _vm.form.address1,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "address1", $$v)
                          },
                          expression: "form.address1"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "baseInfo.overseaWarehouse.entryRequirements"
                        )
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          no: "entryRequirements",
                          disabled: !_vm.isAdmin && _vm.form.ifFba
                        },
                        model: {
                          value: _vm.form.entryRequirements,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "entryRequirements", $$v)
                          },
                          expression: "form.entryRequirements"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary", no: "save" }, on: { click: _vm.save } },
            [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      ),
      _c("location-search-dialog", {
        attrs: { visible: _vm.cityDialogVisible },
        on: {
          "update:visible": function($event) {
            _vm.cityDialogVisible = $event
          },
          addCallBack: _vm.selectLocalHandler,
          close: function($event) {
            _vm.cityDialogVisible = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }